// removed by extract-text-webpack-plugin
module.exports = {"foundation-grid":"foundation-grid__oLb_m","paper":"paper__1S-Qb","save-btn":"save-btn__3fseb","primary":"primary__3wfbl","secondary":"secondary__18Vzm","blue":"blue__xO1gj","footer":"footer__1VKZp","fr":"fr__AhJ77","right-align":"right-align__1SD3G","center-align":"center-align__1ivOJ","homepage-wrapper":"homepage-wrapper__27CMD","float-right":"float-right__1PLJ2","float-left":"float-left__1Jk2O","elev-button-wrapper":"elev-button-wrapper__Ptua0","elev-btn":"elev-btn__1QMsF"};


//////////////////
// WEBPACK FOOTER
// ./styles/index.scss
// module id = 176
// module chunks = 68